import { z } from "zod";
import { MetaSchema } from "./shared";

export const PrincipalReturnDetailSchema = z.object({
  transactionId: z.string().uuid(),
  amount: z.string(),
  investmentStart: z.string().datetime(),
  investmentEnd: z.string().datetime(),
  status: z.string(),
  totalReturned: z.number(),
});

export const PrincipalReturnsDetailsDataSchema = z.array(
  PrincipalReturnDetailSchema,
);

const UsersInvestmentsPrincipalReturnsDetailsResponse = z.object({
  data: PrincipalReturnsDetailsDataSchema,
  meta: MetaSchema.default,
});

export type UsersInvestmentsPrincipalReturnsDetailsResponseType = z.infer<
  typeof UsersInvestmentsPrincipalReturnsDetailsResponse
>;

export default UsersInvestmentsPrincipalReturnsDetailsResponse;
